module.exports = __webpack_public_path__ + "img/icon7_highlight.8e7ac8dd.png";